<template>
  <transition name="modalbg">
    <div @click.self="closeModal" class="modal_container">
      <transition name="modal" v-on:before-leave="modalClose">
        <div v-if="showed" class="modal">
          <div class="caption">
            <div class="title-modal">{{textContent.titleAdd}}</div>
            <div @click="closeModal" class="close"></div>
          </div>
          <div class="modal-scroll" :class="{ 'in-last-tab' : isLastTab }">
            <div class="modal-content">
              <form v-on:submit.prevent="addItem">
                <form-input name="title"></form-input>
                <form-input name="video"></form-input>
                <calendar name="date_start"></calendar>
                <form-time name="time_start"></form-time>
                <form-drop-down title="title" name="author_id" :id="parentId.experts"
                                :url="apiUrls.content"></form-drop-down>
                <form-drop-down title="title" name="author_article_id" :id="parentId.authors"
                                :url="apiUrls.content"></form-drop-down>
                <form-drop-down title="title" name="parent_id" :id="parentId.lectures"
                                :url="apiUrls.content"></form-drop-down>
                <div class="checkbox-group">
                  <checkbox name="show_author"></checkbox>
                  <checkbox name="show_date"></checkbox>
                </div>
                <form-file use-case="cover" name="img"></form-file>
                <form-input name="seo_alt"></form-input>
                <form-text-area name="subtext"></form-text-area>
                <form-text-editor name="text" editor-id="editor"></form-text-editor>
                <form-input name="seo_title"></form-input>
                <form-text-area name="seo_key"></form-text-area>
                <form-text-area name="seo_desc"></form-text-area>
              </form>
            </div>
          </div>
          <div class="buttons">
            <div class="next">
              <button @click="closeModal" class="cancel">{{textContent.cancelButton}}</button>
              <button class="confirm" @click="onAddItem">{{textContent.submitButton}}</button>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
  import IconAlignleft from '@/components/icons/IconAlignleft'
  import IconSignalbars from '@/components/icons/IconSignalbars'
  import IconArrowbold from '@/components/icons/IconArrowbold'
  import FormInput from '@/components/create-form/Input'
  import FormTextArea from '@/components/create-form/TextArea'
  import Calendar from '@/components/create-form/Calendar'
  import FormFile from '@/components/create-form/File'
  import FormDropDown from '@/components/create-form/DropDown'
  import FormTextEditor from '@/components/create-form/TextEditor'
  import {createNamespacedHelpers} from 'vuex'
  import Tabs from '@/components/create-form/Tabs'
  import Checkbox from '@/components/create-form/Checkbox'
  import FormTime from '@/components/create-form/TimePicker'

  const {mapMutations, mapActions, mapState, mapGetters} = createNamespacedHelpers('mainPage')

  export default {
    data () {
      return {
        showed: false,
      }
    },
    computed: {
      ...mapState([
        'textContent',
        'fields'
      ]),
      ...mapGetters([
        'getDataFromEditor',
        'isLastTab'
      ]),
      apiUrls () {
        return this.$store.state.apiUrls
      },
      parentId () {
        return this.$store.state.parentId
      }
    },
    methods: {
      ...mapActions([
        'modalClose',
        'addItem',
        'initFields',
        'onNext',
        'onPrev',
        'checkTabAwailability',
        'addToNews'
      ]),
      ...mapMutations([
        'setField',
        'resetTextEditor',
        'setTabs',
        'setCurrentTabId',
        'setFileExtensions'
      ]),
      onAddItem () {
        this.setField({fieldId: 'text', fieldPropertyId: 'value', value: this.fields.text.editor.getData()})
        this.addItem()
        this.addToNews({
          title: this.fields.title.value,
          url: {
            path: 'lektsii-online',
            categoryId: null
          },
          img: this.fields.img.value,
          subtext: this.fields.subtext.value
        })
      },
      closeModal () {
        this.showed = false
      }
    },
    mounted () {
      this.showed = true
      this.checkTabAwailability()
    },
    created () {
      this.setCurrentTabId(0)
      this.setFileExtensions({img: ['jpg', 'jpeg', 'png', 'gif']})
      this.initFields({
        title: {
          value: '',
          parameterName: 'title',
          name: 'Название лекции',
          errorId: null,
          errors: {empty: 'Введите название лекции'},
          tabId: 0
        },
        time_start: {
          value: '',
          parameterName: 'time_start',
          name: 'Время проведения',
          errorId: null,
          errors: {empty: 'Выберите время проведения'},
          tabId: 0
        },
        date_start: {
          value: '',
          parameterName: 'date_start',
          name: 'Дата проведения',
          errorId: null,
          errors: {empty: 'Выберите дату проведения'},
          tabId: 0
        },
        author_id: {
          value: '',
          parameterName: 'author_id',
          name: 'Эксперт',
          errorId: null,
          errors: {empty: 'Выберите эксперта'},
          tabId: 0,
          isNullable: true
        },
        parent_id: {
          value: '',
          parameterName: 'parent_id',
          name: 'Категория',
          errorId: null,
          errors: {empty: 'Выберите категорию'},
          tabId: 0,
        },
        author_article_id: {
          value: '',
          parameterName: 'author_article_id',
          name: 'Автор статьи',
          type: 'object',
          errorId: null,
          errors: {empty: 'Выберите автора статьи'},
          tabId: 0
        },
        video: {
          value: '',
          parameterName: 'video',
          name: 'Ссылка на трансляцию',
          type: 'object',
          errorId: null,
          isNullable: true,
          tabId: 0
        },
        show_author: {
          value: true,
          parameterName: 'show_author',
          name: 'Отображать автора',
          errorId: null,
          tabId: 0,
          isNullable: true
        },
        show_date: {
          value: true,
          parameterName: 'show_date',
          name: 'Отображать дату',
          errorId: null,
          tabId: 0,
          isNullable: true
        },
        img: {
          value: '',
          parameterName: 'img',
          name: 'Изображение',
          errorId: null,
          errors: {empty: 'Выберите изображение', extension: 'Допустимые расширения: jpg, jpeg, png, gif'},
          fileName: '',
          tabId: 0
        },
        seo_alt: {
          value: '',
          parameterName: 'seo_alt',
          name: 'Альтернативный текст',
          errorId: null,
          isNullable: true,
          errors: {empty: 'Введите альтернативный текст'},
          tabId: 0
        },
        subtext: {
          value: '',
          parameterName: 'subtext',
          name: 'Краткое описание',
          errorId: null,
          errors: {empty: 'Введите краткое описание'},
          tabId: 0,
        },
        text: {
          value: '',
          parameterName: 'text',
          name: 'Текст',
          errorId: null,
          errors: {empty: 'Введите текст'},
          tabId: 0,
        },
        seo_title: {
          value: '',
          parameterName: 'seo_title',
          name: 'Название страницы',
          errorId: null,
          errors: {empty: 'Напишите название страницы'},
          tabId: 0
        },
        seo_key: {
          value: '',
          parameterName: 'seo_key',
          name: 'Ключевые слова',
          errorId: null,
          errors: {empty: 'Напишите ключевые слова'},
          tabId: 0,
          isNullable: true
        },
        seo_desc: {
          value: '',
          parameterName: 'seo_desc',
          name: 'Краткое описание',
          errorId: null,
          errors: {empty: 'Напишите краткое описание'},
          tabId: 0
        },
        content_id: {
          value: this.$store.state.parentId.lectures,
          parameterName: 'content_id',
          errorId: null,
          isNullable: true,
        },
      })
    },
    components: {
      Checkbox,
      IconAlignleft,
      IconSignalbars,
      IconArrowbold,
      FormInput,
      FormTextArea,
      FormFile,
      FormDropDown,
      FormTextEditor,
      Tabs,
      FormTime,
      Calendar
    }
  }
</script>

<style scoped>
  .modal_container .modal form .dropdown {
    margin: 28px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/lectures/articles/CreateModal.vue